import React, { useState } from "react"
import { Container, Navbar, Nav, Dropdown, Offcanvas, Button } from "react-bootstrap"
import { Link, useLocation } from "react-router-dom"
import { useAuth } from "../../context/AuthContext"
import { routeConfig } from "../../routes"
import logo from "../../assets/images/logo.png"

const Header = () => {
  const { doLogout, user, getAppLookupValue, isAdmin, appLookups } = useAuth()
  const [show, setShow] = useState(false)
  const location = useLocation()

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  // Get navigation routes (excluding login and dynamic routes)
  const navigationRoutes = Object.values(routeConfig)
    .filter(
      route =>
        route.path !== "/login" &&
        route.path !== "/profile" &&
        route.protected &&
        !route.path.includes(":") &&
        (!route.adminOnly || isAdmin())
    )
    .map(route => ({
      ...route,
      icon: route.icon || (route.path === "/" ? "fa-home" : undefined)
    }))

  return (
    <>
      <Navbar expand="lg" className="shadow-sm navbar">
        <Container fluid className="px-4">
          {/* Logo */}
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center me-3 logo">
            <img src={logo} alt="eExpert logo" className="d-inline-block align-top" />
          </Navbar.Brand>

          {/* Mobile Menu Toggle */}
          <Button variant="" onClick={handleShow} className="text-white d-lg-none me-2">
            <i className="fas fa-bars" />
          </Button>

          {/* Navigation */}
          <div className="d-flex align-items-center">
            {/* Desktop Navigation */}
            <Nav className="d-none d-lg-flex">
              {navigationRoutes.map(route => (
                <Nav.Link
                  key={route.path}
                  as={Link}
                  to={route.path}
                  className={`d-flex align-items-center ${location.pathname === route.path ? "active" : ""}`}>
                  <i className={`fas ${route.icon} me-2`} />
                  {route.name}
                </Nav.Link>
              ))}
            </Nav>
          </div>

          {/* User Menu */}
          <Nav className="ms-auto">
            <Dropdown align="end" className="dropdown">
              <Dropdown.Toggle variant="link" className="text-decoration-none d-flex align-items-center">
                <div className="d-flex flex-column text-end me-2">
                  <span className={`fw-medium ${user?.RoleID === 0 ? "text-warning" : ""}`}>
                    {user?.Firstname} {user?.LastName}
                  </span>
                  <small className={user?.RoleID === 0 ? "text-warning" : "text-muted"}>
                    {appLookups ? getAppLookupValue("UsersRoles", user?.RoleID) : "Φόρτωση..."}
                  </small>
                </div>
                <div className="d-flex align-items-center">
                  <i
                    className={`fas fa-user-circle fa-2x me-2 ${
                      user?.RoleID === 0 ? "text-warning" : "text-muted"
                    }`}
                  />
                  <i
                    className={`fas fa-chevron-down ${user?.RoleID === 0 ? "text-warning" : "text-muted"}`}
                    style={{ pointerEvents: "none" }}
                  />
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  as={Link}
                  to="/profile"
                  className={location.pathname === "/profile" ? "active" : ""}>
                  <i className="fas fa-user me-2" />
                  Προφίλ
                </Dropdown.Item>
                <Dropdown.Item onClick={doLogout}>
                  <i className="fas fa-sign-out-alt me-2" />
                  Αποσύνδεση
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Container>
      </Navbar>
      
      {/* Mobile Offcanvas Menu */}
      <Offcanvas show={show} onHide={handleClose} className="d-lg-none bg-dark">
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            {navigationRoutes.map(route => (
              <Nav.Link
                key={route.path}
                as={Link}
                to={route.path}
                className={`text-secondary d-flex align-items-center ${
                  location.pathname === route.path ? "active" : ""
                }`}
                onClick={handleClose}>
                <i className={`fas ${route.icon} me-2`} />
                {route.name}
              </Nav.Link>
            ))}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default Header
